import { gql, useQuery } from '@apollo/client'

export const GET_LEADS = gql`
  query CoachingLeads {
    coachingInquiries {
      id
      createdAt
      viewedAt
      firstMessagedAt
      intent
      contact {
        id
        firstName
        lastName
        email
        phone
        externalId
        banned
      }
    }
    currentUser {
      attributes {
        ... on Coach {
          freeTierLimitsReached
        }
      }
    }
  }
`

const GET_LEAD = gql`
  query CoachingInquiryQuery($id: ID!) {
    coachingInquiry(id: $id) {
      id
      intent
      createdAt
      viewedAt
      contact {
        firstName
        lastName
        email
        phone
        phoneNumber
        externalId
        banned
      }
      coachProfile {
        id
      }
      questionnaire {
        question
        answer
      }
    }
  }
`

export function useGetLeads() {
  return useQuery(GET_LEADS, { errorPolicy: 'all', fetchPolicy: 'no-cache' })
}

export function useGetLead(leadId) {
  return useQuery(GET_LEAD, {
    variables: { id: leadId },
  })
}
